/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mail_Compose_SendInputs */

const en_mail_compose_send = /** @type {(inputs: Mail_Compose_SendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send (${i?.count})`)
};

const de_mail_compose_send = /** @type {(inputs: Mail_Compose_SendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Senden (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Send ({count})" |
*
* @param {Mail_Compose_SendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_send = /** @type {((inputs: Mail_Compose_SendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_SendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_send(inputs)
	return en_mail_compose_send(inputs)
});